module.exports = __webpack_public_path__ + "static/img/scratch-mask.1f760c8b.png";